import pt from '@/locales/languages/pt.json';
import br from '@/locales/languages/br.json';
import en from '@/locales/languages/en.json';
import es from '@/locales/languages/es.json';
import ar from '@/locales/languages/ar.json';
import ru from '@/locales/languages/ru.json';
import fr from '@/locales/languages/fr.json';
import it from '@/locales/languages/it.json';
import de from '@/locales/languages/de.json';

export default function langsList(code, storeLanguage) {

    let lang = [];

    switch (storeLanguage) {
        case "pt":
            lang = pt;
            break;

        case "br":
            lang = br;
            break;

        default:
        case "en":
            lang = en;
            break;

        case "es":
            lang = es;
            break;

        case "ar":
            lang = ar;
            break;

        case "ru":
            lang = ru;
            break;

        case "fr":
            lang = fr;
            break;

        case "it":
            lang = it;
            break;

        case "de":
            lang = de;
            break;
    }

    return lang.filter((item) => item.code === code).map(item => item.value).join();
}